export { default } from './part-mobile-menu';
